import {
  compactFormat,
  dataLabelsCompact,
  dataLabelsDecimals,
  dataLabelsLinesSizes,
  dataLabelsSizes,
  dimension,
  dimensionSelector,
  granularity,
  legendPosition,
  lineThickness,
  palette,
  showBarDataLabels,
  showItems,
  showLineDataLabels,
} from "@/settings/charts/settingsDictionary";
import { FAMILY } from "@/settings/widgetFamilies";
import { Config } from "@/types/charts";

export default <Config>{
  family: [FAMILY.OVERTIME, FAMILY.COMPARISON],
  title: "Combo Bar & Line Chart",
  defaultHeight: 6,
  dataModes: ["project", "explore", "dual"],
  controls: [{ ...dimension, metricName: "yAxis" }, granularity],
  settings: {
    lineThickness: { ...lineThickness, gridPosition: [3, 0], default: 2 },
    showItems: { ...showItems, gridPosition: [4, 0] },
    legendPosition: { ...legendPosition, gridPosition: [5, 0] },
    compactFormat: { ...compactFormat, gridPosition: [6, 0] },

    yAxis: {
      default: "channel",
      type: "select",
      label: "Vertical Axis Metric",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },

    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [0, 1],
      forAxis: "yAxis",
    },

    xAxisPrimary: {
      default: "spend",
      type: "select",
      label: "Horizontal Axis Metric 1 (Bars)",
      dictionary: "displayMetrics",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },

    xAxisPrimaryTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis 1 Title",
      gridPosition: [1, 1],
      forAxis: "xAxisPrimary",
    },

    xAxisSecondary: {
      default: "impressions",
      type: "select",
      label: "Horizontal Axis Metric 2 (Line)",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 2,
    },

    xAxisSecondaryTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis 2 Title",
      gridPosition: [2, 1],
      forAxis: "xAxisSecondary",
    },

    palette,
  },
  planSettings: {
    lineThickness: { ...lineThickness, gridPosition: [3, 0], default: 2 },
    showItems: { ...showItems, gridPosition: [4, 0] },
    legendPosition: { ...legendPosition, gridPosition: [5, 0] },
    compactFormat: { ...compactFormat, gridPosition: [6, 0] },

    showBarDataLabels: { ...showBarDataLabels, gridPosition: [8, 0] },
    dataLabelsSizes: { ...dataLabelsSizes, gridPosition: [8, 1] },

    showLineDataLabels: { ...showLineDataLabels, gridPosition: [9, 0] },
    dataLabelsLinesSizes: { ...dataLabelsLinesSizes, gridPosition: [9, 1] },

    dataLabelsCompact: { ...dataLabelsCompact, gridPosition: [10, 0] },
    dataLabelsDecimals: { ...dataLabelsDecimals, gridPosition: [10, 1] },

    yAxis: {
      default: "channel",
      type: "select",
      label: "Vertical Axis Metric",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },

    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [0, 1],
      forAxis: "yAxis",
    },

    xAxisPrimary: {
      default: "channel_budget",
      type: "select",
      label: "Horizontal Axis Metric 1 (Bars)",
      dictionary: "displayMetrics",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },

    xAxisPrimaryTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis 1 Title",
      gridPosition: [1, 1],
      forAxis: "xAxisPrimary",
    },

    xAxisSecondary: {
      default: "impressions",
      type: "select",
      label: "Horizontal Axis Metric 2 (Line)",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 2,
    },

    xAxisSecondaryTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis 2 Title",
      gridPosition: [2, 1],
      forAxis: "xAxisSecondary",
    },

    palette,
  },
  planExploreSettings: {
    lineThickness: { ...lineThickness, gridPosition: [3, 0], default: 2 },
    showItems: { ...showItems, gridPosition: [4, 0] },
    legendPosition: { ...legendPosition, gridPosition: [5, 0] },
    compactFormat: { ...compactFormat, gridPosition: [6, 0] },

    showBarDataLabels: { ...showBarDataLabels, gridPosition: [8, 0] },
    dataLabelsSizes: { ...dataLabelsSizes, gridPosition: [8, 1] },

    showLineDataLabels: { ...showLineDataLabels, gridPosition: [9, 0] },
    dataLabelsLinesSizes: { ...dataLabelsLinesSizes, gridPosition: [9, 1] },

    dataLabelsCompact: { ...dataLabelsCompact, gridPosition: [10, 0] },
    dataLabelsDecimals: { ...dataLabelsDecimals, gridPosition: [10, 1] },

    yAxis: {
      default: "channel",
      type: "select",
      label: "Vertical Axis Metric",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },

    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [0, 1],
      forAxis: "yAxis",
    },

    xAxisPrimary: {
      default: "spend",
      type: "select",
      label: "Horizontal Axis Metric 1 (Bars)",
      dictionary: "displayMetrics",
      gridPosition: [1, 0],
      tooltipOrder: 1,
    },

    xAxisPrimaryTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis 1 Title",
      gridPosition: [1, 1],
      forAxis: "xAxisPrimary",
    },

    xAxisSecondary: {
      default: "impressions",
      type: "select",
      label: "Horizontal Axis Metric 2 (Line)",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 2,
    },

    xAxisSecondaryTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis 2 Title",
      gridPosition: [2, 1],
      forAxis: "xAxisSecondary",
    },

    palette,
  },
  planDualSettings: {
    palette,
    xAxisPrimarySource: {
      default: "plan",
      dictionary: "metricSources",
    },
    xAxisSecondarySource: {
      default: "explore",
      dictionary: "metricSources",
    },
    yAxis: {
      default: "channel",
      type: "select",
      label: "Grouping Dimension (Project + Explore)",
      dictionary: "dualDimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [0, 1],
      forAxis: "yAxis",
    },
    xAxisPrimary: {
      default: "channel_budget",
      type: "select",
      label: "Primary Metric (Bars)",
      dictionary: "displayMetrics",
      sourceFrom: "xAxisPrimarySource",
      gridPosition: [2, 0],
      tooltipOrder: 1,
    },
    xAxisPrimaryTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis 1 Title",
      gridPosition: [2, 1],
      forAxis: "xAxisPrimary",
    },
    xAxisSecondary: {
      default: "spend",
      type: "select",
      label: "Secondary Metric (Line)",
      dictionary: "displayMetrics",
      sourceFrom: "xAxisSecondarySource",
      gridPosition: [3, 0],
      tooltipOrder: 2,
    },
    xAxisSecondaryTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis 2 Title",
      gridPosition: [3, 1],
      forAxis: "xAxisSecondary",
    },
    lineThickness: { ...lineThickness, gridPosition: [4, 0], default: 2 },
    showItems: { ...showItems, gridPosition: [5, 0] },
    legendPosition: { ...legendPosition, gridPosition: [6, 0] },
    compactFormat: { ...compactFormat, gridPosition: [7, 0] },
    showBarDataLabels: { ...showBarDataLabels, gridPosition: [8, 0] },
    dataLabelsSizes: { ...dataLabelsSizes, gridPosition: [8, 1] },
    showLineDataLabels: { ...showLineDataLabels, gridPosition: [9, 0] },
    dataLabelsLinesSizes: { ...dataLabelsLinesSizes, gridPosition: [9, 1] },
    dataLabelsCompact: { ...dataLabelsCompact, gridPosition: [10, 0] },
    dataLabelsDecimals: { ...dataLabelsDecimals, gridPosition: [10, 1] },
  },
  familySettings: {
    [FAMILY.OVERTIME]: {
      yAxis: {
        default: "month",
        type: "select",
        label: "Vertical Axis Metric",
        dictionary: "timeMetrics",
        apiParameter: "dimension",
        gridPosition: [0, 0],
        tooltipOrder: 0,
      },
      showItems: undefined,
      legendPosition: { ...legendPosition, gridPosition: [4, 0] },
      compactFormat: { ...compactFormat, gridPosition: [5, 0] },
    },
    [FAMILY.COMPARISON]: {
      dimensionSelector: { ...dimensionSelector, gridPosition: [7, 0] },
    },
  },
};
